import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/select";

const ExtractionTypeSelect = ({
  value,
  onChange,
}: { value: string; onChange: (value: string) => void }) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Field Type" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="string">String</SelectItem>
          <SelectItem value="int">Integer</SelectItem>
          <SelectItem value="boolean">Bool</SelectItem>
          <SelectItem value="float">Float</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default ExtractionTypeSelect;
